import type { ExportActionContext } from 'cadenza/workbook/actions/export-actions';
import type { DataViewId } from 'cadenza/workbook/model/data-view-id.gen';

export async function openExportGeopackageDialog(
  dataViewId: DataViewId,
  actionContext: ExportActionContext,
  exportIndividualValuesDrillThrough = false,
) {
  const { GeoPackageExportDialog } = await import('cadenza/geo-package-export-dialog/geo-package-export-dialog');
  const dialog = new GeoPackageExportDialog(dataViewId, actionContext, exportIndividualValuesDrillThrough);
  dialog.connectAndShow();
}
